import * as React from 'react';
import { UIHeading3, UIText1 } from '@cian/ui-kit';
import { IMortgageStep } from '../../types/proposal';

export const Step: React.FC<{ step: IMortgageStep }> = ({ step }) => {
  return (
    <div>
      <UIHeading3>{step.title}</UIHeading3>
      <UIText1>{step.description}</UIText1>
    </div>
  );
};
